import classNames from 'classnames';
import React from 'react';
import styles from './Card.module.scss';
function Card({ size = 'm', bgColor = 'white', noPd = false, disabled = false, noHover = false, onClick, children, }) {
    const classes = classNames(styles.wrap, styles[size], styles[bgColor], {
        [styles.noPd]: noPd,
        [styles.disabled]: disabled,
        [styles.hover]: !noHover,
        [styles.clickable]: !!onClick,
    });
    if (onClick) {
        return (React.createElement("div", { className: classes, onClick: onClick, onKeyDown: (e) => e.key === 'Enter' && onClick(), role: "button", tabIndex: 0 }, children));
    }
    return React.createElement("div", { className: classes }, children);
}
export default Card;
